
import { controls } from "../controls";
const loanrequestagri = {
  label: "Loan Request ",
  pageLabel: "Loan Request & Disburse",
  starting: true,
  url: "loanrequestagri",
  formActions: { edit: { allow: true } },
  pageType: "history",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     },
  //   ]
  // },
  // filter: [

  //   ...controls.displayText({ tab: "filter", label: "PACS ID", width: "col-sm-1" }),
  //   ...controls.text({ placeHolder: "PACS ID", name: "pacs_id", width: "col-sm-2" }),

  //   ...controls.displayText({ tab: "filter", label: "Member ID", width: "col-sm-1" }),
  //   ...controls.text({ placeHolder: "Member ID", name: "member_id", width: "col-sm-2" }),

  //   ...controls.displayText({ tab: "filter", label: "Ref ID", width: "col-sm-1" }),
  //   ...controls.text({ tab: "filter", name: "member_ref_id", width: "col-sm-2", placeHolder: "Ref ID" }),
  // ],

  form: [


    ...controls.displayText({ tab: "create", label: "PACS ID", width: "col-sm-1" }),
    ...controls.text({ tab: "create", placeHolder: "PACS ID", name: "pacs_id", width: "col-sm-2" }),

    ...controls.displayText({ tab: "create", label: "Account No", width: "col-sm-1" }),
    ...controls.AccountNumber({ tab: "create" }),
    ...controls.showData({ tab: "create", data: "account_number_display", name: "account_number_display", width: "col-sm-3" }),


    ...controls.displayText({ tab: "create", label: "Member ID", width: "col-sm-1" }),
    ...controls.text({ tab: "create", placeHolder: "Member ID", name: "member_id", width: "col-sm-2" }),
    // ...controls.displayText({ tab: "create", label: "", width: "col-sm-5" }),



    ...controls.displayText({ tab: "create", label: "Crop", width: "col-sm-1" }),
    ...controls.text({ tab: "create", name: "crop_id", width: "col-sm-2", placeHolder: "" }),

    ...controls.displayText({ tab: "create", label: "Land Type", width: "col-sm-1" }),
    ...controls.select({
      tab: "create", name: "land_type", width: "col-sm-2", defaultValue: "",
      options: [{
        label: "Irrigated",
        value: "irrigated"
      },
      {
        label: "Non Irrigated",
        value: "non_irrigated"
      }]
    }),

    ...controls.displayText({ tab: "create", label: "Land Area", width: "col-sm-1" }),
    ...controls.numberOnly({ tab: "create", name: "land_area", placeholder: "in Acres", width: "col-sm-2" }),



    ...controls.displayText({ tab: "create", label: "Calculated Amt", width: "col-sm-1" }),
    ...controls.numberOnly({ tab: "create", isReadOnly: true, name: "calculated_amount", width: "col-sm-2" }),

    ...controls.displayText({ tab: "create", label: "Requested Amt", width: "col-sm-1" }),
    ...controls.numberOnly({ tab: "create", name: "requested_amount", width: "col-sm-2" }),

    ...controls.displayText({ tab: "create", label: "Sanctioned Amt", width: "col-sm-1" }),
    ...controls.numberOnly({ tab: "create", name: "sanctioned_amount", width: "col-sm-2" }),

    ...controls.displayText({ tab: "create", label: "Shares Amt", width: "col-sm-1" }),
    ...controls.numberOnly({ tab: "create", name: "shares_amount", width: "col-sm-2" }),

    ...controls.displayText({ tab: "create", label: "Insurance Amt", width: "col-sm-1" }),
    ...controls.numberOnly({ tab: "create", name: "insurance_premium_amount", width: "col-sm-2" }),

    ...controls.displayText({ tab: "create", label: "Disbursable", width: "col-sm-1" }),
    ...controls.numberOnly({ tab: "create", isReadOnly: true, name: "disbursable_amount", width: "col-sm-2" }),

    ...controls.displayText({ tab: "create", label: "Disbursed Amt", width: "col-sm-1" }),
    ...controls.numberOnly({ tab: "create",  name: "disbursed_amount", width: "col-sm-2" }),


    ...controls.button({
      label: "ADD", style: { padding: 0 },
      Bcolor: "success", onclick: {
        action: "appendToHTMLTable",
        tableNameField: 'loan_requests_table',
        requiredField: ["pacs_id", "member_id", "crop_id", "land_type", "land_area", "requested_amount", "disbursable_amount","disbursed_amount", "sanctioned_amount", "shares_amount", "insurance_premium_amount"]
      }, width: "col-sm-1"
    }),

    ...controls.displayText({ tab: "create", label: "", width: "col-sm-2" }),

    ...controls.displayText({ tab: "create", label: "Total Disbursed", width: "col-sm-1" }),
    ...controls.numberOnly({ tab: "create", isReadOnly: true, name: "total_disbursed_amount",style:{backgroundColor:"#990000"}, width: "col-sm-2" }),



    {
      inputType: "table",
      tab: "create",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "PACS ID", field: "pacs_id" },
        { label: "Member ID", field: "member_id" },
        { label: "Crop", field: "crop_id" },
        { label: "Land", field: "land_type" },
        { label: "Area", field: "land_area" },
        { label: "Requested", field: "requested_amount" },
        { label: "Disbursable", field: "disbursable_amount" },
        { label: "Disbursed", field: "disbursed_amount" },
        { label: "Sanctioned", field: "sanctioned_amount" },
        { label: "Shares", field: "shares_amount" },
        { label: "Premium", field: "insurance_premium_amount" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "loan_requests_table",
      onRender: [
        { f: 'tableCalculations', calcType: 'sum', inputs: { source: 'pageData.loan_requests_table', field: 'disbursed_amount' }, resultVar: 'totalAmount' },
        // { f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'allResults', field: 'totalAmount' }, { source: 'pageData.total_recovered_amount' }], resultVar: 'total' },
        { f: 'setParentState', inputs: { dest: "pageData.total_disbursed_amount", source: 'allResults', field: 'totalAmount' }, resultVar: "total_disbursed_amount" },
      ]
    }
  ],
  // history: {
  //   perPage: 10,
  //   reportHeader: "Deposit Accounts",
  //   pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
  //   clickable: true,
  //   displayColumns: [
  //     {
  //       Header: "PACS ID",
  //       accessor: "pacs_id"
  //     },
  //     {
  //       Header: "Account Number",
  //       accessor: "account_number",
  //     },
  //     {
  //       Header: "Member ID",
  //       accessor: "member_id",
  //       width: 150
  //     },
  //     {
  //       Header: "Member Name",
  //       accessor: "member_name"
  //     },
  //     {
  //       Header: "Reference ID",
  //       accessor: "ref_id"
  //     }
  //   ]
  // }
};

export default loanrequestagri;